import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "81",
  height: "64",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m49.323 40.25.713 12.4-10.408 6.835 2.745 4.18 10.376-6.814 11.213 5.641 2.247-4.466L55.03 52.4l-.715-12.438zM63.6.83l.713 12.4-10.408 6.835 2.744 4.18 10.377-6.814 11.212 5.641 2.248-4.466-11.18-5.625L68.592.543zM10.578 51.96l-.714-12.4 4.992-.287.715 12.438 11.18 5.624-2.248 4.467-11.213-5.642-10.376 6.814-2.745-4.18zm15.809-48.47.713 12.4-10.408 6.835 2.744 4.18 10.377-6.814 11.212 5.641 2.248-4.466-11.18-5.625-.714-12.438z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }